import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/shared/lib/query/queryKeys';
import { fetchAvailableCoupons, type AvailableCoupon } from './couponApi';

/** Coupons the wallet owner can use for an order of `amount`. */
export function useAvailableCouponsQuery(amount: number, enabled = true) {
  const rounded = Math.round(Number(amount) || 0);
  const query = useQuery({
    queryKey: queryKeys.coupons.available(rounded),
    queryFn: () => fetchAvailableCoupons(rounded),
    enabled: enabled && rounded > 0,
    refetchOnWindowFocus: false,
  });

  return {
    coupons: (query.data?.data ?? []) as AvailableCoupon[],
    isLoading: query.isLoading,
  };
}
